(function() {
    "use strict";

    function waitForUtils(callback) {
        if (window.XotinyUtils && window.XotinyUtils.XoComponent) {
            callback(window.XotinyUtils);
        } else {
            setTimeout(() => waitForUtils(callback), 50);
        }
    }

    waitForUtils(function(XotinyUtils) {
        const BaseElement = XotinyUtils.XoComponent;
        const delay = XotinyUtils.delay;
        const storage = XotinyUtils.storage;
        const defineElement = XotinyUtils.componentDefine;

        class XoPopupIpPromo extends BaseElement {
            static propTypes = {
                xoObserved: "string",
                xoShow: "boolean",
                xoWhen: "string",
                xoDelay: "number",
                xoScroll: "string",
                xoFrequency: "string"
            };

            static defaultProps = {
                xoObserved: "observed",
                xoShow: true,
                xoWhen: "immediately",
                xoDelay: 0,
                xoScroll: "none",
                xoFrequency: "once"
            };

            static observedProps = ["xoObserved"];

            constructor() {
                super(...arguments);
                
                this.state = {
                    isActive: false
                };

                this.scrollPercent = () => {
                    const { isActive } = this.state;
                    const { xoScroll } = this.props;
                    
                    const modalElement = this.querySelector("xo-modal");
                    const modalName = modalElement?.getAttribute("xo-name");
                    
                    const scrollY = window.scrollY;
                    const pageHeight = document.body.offsetHeight;
                    const viewportHeight = window.innerHeight;
                    const scrollRatio = scrollY / (pageHeight - viewportHeight);
                    const scrollPercentage = Math.round(scrollRatio * 100);

                    if (!isActive) {
                        if (xoScroll === "none") {
                            this.openPopup(modalName, 0);
                        } else {
                            const threshold = Number(xoScroll ?? 0);
                            if (scrollPercentage >= threshold) {
                                this.openPopup(modalName, 0);
                            }
                        }
                    }
                };

                this.popup = () => {
                    const { xoShow, xoWhen, xoDelay } = this.props;
                    
                    const modalElement = this.querySelector("xo-modal");
                    const modalName = modalElement?.getAttribute("xo-name");

                    if (!xoShow || !modalName) return;

                    if (xoWhen === "immediately") {
                        this.openPopup(modalName, xoDelay ?? 0);
                    } else {
                        this.scrollPercent();
                        window.addEventListener("scroll", this.scrollPercent);
                    }
                };
            }

            mount() {
                this.setState({ isActive: false });
                this.popup = this.popup.bind(this);
                this.scrollPercent = this.scrollPercent.bind(this);
                this.init();
            }

            unmount() {
                this.destroy();
            }

            async openPopup(modalName, delayMs) {
                await delay(delayMs);
                window.xoModal.open(modalName);
                
                const timestamp = Math.floor(Date.now() / 1000) + "";
                storage.setItem("xo-popup-ip-promo", timestamp);
                this.setState({ isActive: true });
            }

            shouldShowPopup(frequency) {
                const frequencyMap = {
                    once: Infinity,
                    every_hour: 3600,
                    every_12_hour: 43200,
                    every_day: 86400,
                    every_3_day: 259200,
                    every_week: 604800,
                    every_2_weeks: 1209600,
                    no_limit: 0
                };

                const lastShownTime = storage.getItem("xo-popup-ip-promo");
                const currentTime = Math.floor(Date.now() / 1000);
                const intervalSeconds = frequencyMap[frequency];

                if (intervalSeconds === 0 || !lastShownTime) {
                    return true;
                }

                return currentTime - parseInt(lastShownTime) >= intervalSeconds;
            }

            init() {
                const { xoFrequency } = this.props;
                if (this.shouldShowPopup(xoFrequency)) {
                    window.addEventListener("load", this.popup);
                }
            }

            destroy() {
                window.removeEventListener("load", this.popup);
                window.removeEventListener("scroll", this.scrollPercent);
            }
        }

        if (defineElement) {
            defineElement({
                "xo-popup-ip-promo": XoPopupIpPromo
            });
        } else {
            if (!customElements.get("xo-popup-ip-promo")) {
                customElements.define("xo-popup-ip-promo", XoPopupIpPromo);
            }
        }

        window.XoPopupIpPromo = XoPopupIpPromo;
    });
})();